import getAllVariantsProductVariantUtil from 'modules/product-variant/utils/get-all-variants'

const MAX_VARIANTS_TO_SHOW_SMALL_SCREEN = 3
const MAX_VARIANTS_TO_SHOW = 4

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @param {boolean} isExtraExtraSmallScreen
 * @returns {{quickShadeVariants: T[], remainingVariantsCount: number}}
 */
export default function getQuickShadeVariantsProductVariantUtil ({
  featuredProductVariant,
  isExtraExtraSmallScreen
}) {
  const allVariants = getAllVariantsProductVariantUtil(featuredProductVariant)
  const maxVariantsToShow = isExtraExtraSmallScreen
    ? MAX_VARIANTS_TO_SHOW_SMALL_SCREEN
    : MAX_VARIANTS_TO_SHOW
  const quickShadeVariants = allVariants.slice(0, maxVariantsToShow)

  const remainingVariantsCount = allVariants.length - maxVariantsToShow

  return {
    quickShadeVariants,
    remainingVariantsCount
  }
}
